import HttpService from './commons/HttpService';

import moment from 'moment';

const ServiceService = {
  sync(dataList, installationId) {
    return HttpService.post('/services/sync', dataList, { params: { installationId } });
  },
  save(services) {
    if (services.id && services.id > 0) {
      return this.update(services);
    }
    return this.create(services);
  },
  create(services) {
    return HttpService.post('/services', services);
  },
  update(services) {
    return HttpService.put(`/services/${services.id}`, services);
  },
  delete(services) {
    return HttpService.delete(`/services/${services.id}`);
  },
  getById(id) {
    return HttpService.get(`/services/${id}`);
  },
  findAllForCurrentUser() {
    return HttpService.get('/services');
  },
  search(query) {
    return HttpService.get('/services/search', { params: { query } });
  },
  exportForUser() {
    return HttpService.get(
      '/services/exportAllForCurrentUser',

      {
        responseType: 'arraybuffer',
        // headers: {
        //   Accept: 'application/pdf',
        // },
      },
    ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Serviços-' + moment().format('DD-MM-YY HH:mm') + '.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  },

  updateImage({ serviceId, file }) {
    const formData = new FormData();
    formData.append('file', file);

    const config = { headers: { 'content-type': 'multipart/form-data' } };
    return HttpService.put(`/services/${serviceId}/image`, formData, config);
  },
  deleteImage(serviceId) {
    return HttpService.delete(`/services/${serviceId}/image`);
  },
};

export default ServiceService;
